module.exports = __webpack_public_path__ + "img/man.a0422233.png";